import { Col, Row, Button } from "antd";
import { BsCheckLg, BsFillArrowLeftCircleFill, BsFillTrashFill } from "react-icons/bs";
import { FaCube } from "react-icons/fa";
import IntlMessages from "../../../../../domain/utility/IntlMessages";
import { useNavigate } from "react-router-dom";
import { ITagDataProducts } from "../../../../../shared/services/product-tag/dtos/product-tag";
import { useIntl } from "react-intl";

interface ICreateProductTagHeaderProps {
    isSubmitting: boolean;
    productTagDetails?: ITagDataProducts;
    handleSubmit: () => void;
    deleteProductTag: () => void;
}
const CreateProductTagHeader = (props: ICreateProductTagHeaderProps) => {

    const { handleSubmit, isSubmitting, deleteProductTag, productTagDetails } = props;

    const { messages } = useIntl();
    const navigate = useNavigate();

    return(
        <Row>
            <Col lg={16} sm={24}>
                <div className='text-title'>
                    <span className='icon-title'>
                        <FaCube />
                    </span>
                    {
                        productTagDetails ?
                            `${messages['productTags.editProductTagDetails'].toString()} - ${productTagDetails.Name}`
                        :   <IntlMessages id='productTags.addANewProductTag' />
                    }
                    <small className='back-to-list' >
                        <BsFillArrowLeftCircleFill className="back-to-icon" />
                        <a 
                            onClick={() => {
                                navigate("/catalog/product-tags");
                            }}
                        >
                            <IntlMessages id='productTags.backToProductTagList' />
                        </a>
                    </small>
                </div>
            </Col>
            <Col lg={8}>
                <Row justify="end" gutter={[20, 0]}>
                    <Col>
                        <Button
                            icon={<BsCheckLg className="add-button-icon" />}
                            onClick={handleSubmit}
                            type="primary"
                            size='small'
                            className="add-button"
                            loading={isSubmitting}
                        >
                            <IntlMessages id="common.save" />
                        </Button>
                    </Col>
                    {
                        productTagDetails && (
                            <Col>
                                <Button
                                    icon={<BsFillTrashFill className="add-button-icon" />}
                                    onClick={deleteProductTag}
                                    size='small'
                                    className="add-button"
                                >
                                    <IntlMessages id="common.delete" />
                                </Button>
                            </Col>
                        )
                    }
                </Row>
            </Col>
        </Row>
    );
};

export default CreateProductTagHeader;